import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import '../styles/Certificados.css';

const Certificados = () => {
  const navigate = useNavigate();

  const licenses = [
    {
      category: 'Certificações de Formação',
      items: [
        'Alvará Nº. 1278/309/IET/2023 - Secretaria de Estado de Ensino Técnico Profissional',
        'Certificado de Acreditação 1278/309/IET/2023 - Autoridade Nacional de Educação Profissional',
      ],
    },
    {
      category: 'Certificações de Comércio',
      items: [
        'Alvará nº 17000/11/01/GR/2017 - Indústria e Comércio',
        'Alvará nº 2670/11/01/PS/2015 - Serviços de Consultoria e Auditoria',
      ],
    },
  ];

  return (
    <div className="certificados-page">
      <section className="page-hero" aria-label="Cabeçalho certificados">
        <div className="container">
          <span className="section-subtitle">Conformidade Legal</span>
          <h1 className="section-title">Licenciamento e Acreditações</h1>
          <p className="section-description">Certificações oficiais que comprovam nossa conformidade com padrões nacionais de formação e comércio em segurança contra incêndios.</p>
        </div>
      </section>
      <section className="certificados-section">
        <div className="container">
          <div className="section-header">
            <span className="section-subtitle">Credibilidade</span>
            <h2>Licenciamento e Acreditações</h2>
            <p>
              Nossas certificações garantem conformidade com padrões nacionais, assegurando qualidade e
              confiabilidade em nossos serviços.
            </p>
          </div>

          <div className="licenses-grid">
            {licenses.map((license, index) => (
              <div key={index} className="license-card" style={{ animationDelay: `${index * 0.2}s` }}>
                <h3>{license.category}</h3>
                <ul className="license-list">
                  {license.items.map((item, itemIndex) => (
                    // eslint-disable-next-line jsx-a11y/no-redundant-roles
                    <li key={itemIndex} role="listitem">
                      <CheckCircle size={20} />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="cta-container">
            <button
              className="btn-primary"
              onClick={() => navigate('/contatos')}
              aria-label="Verificar certificações"
            >
              Verificar Certificações
              <ArrowRight size={20} />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Certificados;